var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.audioUrl)?_c('maptivateInfoButton',{attrs:{"Site_Marker_Number":_vm.Site_Marker_Number,"isPopup":_vm.isPopup,"butType":"audioPlay","width":_vm.width,"color":_vm.appSettings.mediaButtonColor,"icon":_vm.siteAudio__audioPlayIcon_01,"title":_vm.playSite_AudioTitle01,"clickfunction":function () {
      _vm.setSound(_vm.audioUrl, _vm.Point_Name, _vm.Site_Marker_Number);
    }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }